<template>
  <div
    class="subprogram-nba-school-team-page"
    v-if="tabs[activeTabIndex]"
  >
    <!-- Header -->
    <div class="subprogram-nba-school-team-page__header">
      <div class="subprogram-nba-school-team-page__header__buttons">
        <!-- Back button -->
        <app-back-button
          route-name="SubprogramNba"
          :route-params="{
            programId,
            subprogramId,
          }"
          i18n-code="entities.subprogram.nba.tabs.summary"
        />
        <!-- <app-back-button
          i18n-code="common.back.default"
        /> -->
      </div>
    </div>

    <!-- Summary -->
    <subprogram-nba-school-team-page-summary v-if="subpropertyId && tabs[activeTabIndex].type === 'summary'" :teamId="teamId" :programId="programId" :subprogramId="subprogramId"/>
    <!-- Players -->
    <app-player-list-page v-else-if="tabs[activeTabIndex].type === 'players'"/>
    <!-- Parents -->
    <app-parent-list-page v-if="tabs[activeTabIndex].type === 'parents' && subpropertyId " :subpropertyId="subpropertyId"/>

  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import SubprogramNbaSchoolTeamPageSumary from '@modules/subprogram/nba/components/subprogram-nba-school-team-page-summary.vue';

import PlayerListPage from '@modules/player/components/player-list-page.vue';
import ParentListPage from '@modules/parent/components/parent-list-page.vue';

import { get } from 'lodash';

export default {
  name: 'subprogram-nba-school-team-page',

  data() {
    return {
      prevRoute: null
    }
  },

  components: {
    [SubprogramNbaSchoolTeamPageSumary.name]: SubprogramNbaSchoolTeamPageSumary,
    [PlayerListPage.name]: PlayerListPage,
    [ParentListPage.name]: ParentListPage,
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    })
  },

  props: {
    tabName: {
      type: String,
    }, 
    teamId: {
      type: String,
    },
    programId: {
      type: String,
      required: true,
    },
    subprogramId: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      currentManage: 'auth/manage/currentManage',
      tabIndex: 'subprogram/nbaTeam/tabIndex',
      tabs: 'subprogram/nbaTeam/tabs',
      activeTabIndex: 'layout/headerTabs/activeTabIndex',
      program: 'subprogram/nbaTeam/program',
      subprogram: 'subprogram/nbaTeam/subprogram',
      parentRows: 'parent/list/rows',
      playerRows: 'player/list/rows',
    }),

    propertyId() {
      return get(this, 'currentManage.property.id', null);
    },

    subpropertyId() {
      return get(
        this,
        'currentManage.subproperty.id',
        null,
      );
    },

    tabsActive() {
      return this.tabs.filter((tab) => {
        return tab.disabled === false;
      });
    },
  },

  mounted() {
    this.doSetTabs()
    // Player filter
    this.doChangePlayerFilter({
      team: this.teamId
    })
    // Parent filter
    this.doChangeParentFilter({
      team: this.teamId
    })
  },

  beforeDestroy() {
    this.resetTabs();
  },

  methods: {
    ...mapActions({
      setTabs: 'layout/headerTabs/setTabs',
      setActiveTabIndex: 'layout/headerTabs/setActiveTabIndex',
      resetTabs: 'layout/headerTabs/resetTabs',
      setTabIndex: 'subprogram/nbaTeam/setTabIndex',
      doResetTabs: 'subprogram/nbaTeam/doResetTabs',
      doSetTabs: 'subprogram/nbaTeam/doSetTabs',
      doChangePlayerFilter: 'player/list/doChangeFilter',
      doChangeParentFilter: 'parent/list/doChangeFilter',
    }),

    parseActiveTab() {
      var tabIndex = this.tabIndex;

      if (this.tabName) {
        tabIndex = this.tabs.findIndex(
          ({ type }) => type == this.tabName,
        );
      }

      this.setTabIndex(tabIndex);
      this.setActiveTabIndex(this.tabIndex);
    },
  },

  watch: {
    'activeTabIndex': {
      handler: 'parseActiveTab',
    },
    tabs() {
      this.doResetTabs();
      this.setTabs(this.tabsActive);
      this.parseActiveTab(); 
    }
  },

};
</script>

<style lang="scss" scoped>
.subprogram-nba-school-team-page {
  .app-content {
    margin-top: -30px;
  }
}
</style>